import axios from 'axios';
import config from '../../../config'
import baseClient from '../../../services/session/apiClient';

const client = axios.create({ ... baseClient.defaults, baseURL:  config.notificationsApiUrl});

export default client;
